<template>
  <div v-if="configAi">
    <div class="ef-ai">
      <header class="ef-ai-header">
        <ChatHeader @clear="onClearMessage" :showClear="showClear" />
      </header>
      <div class="ef-ai-content">
        <div class="ef-ai-body scrollbar-width-none">
          <div class="ef-ai-body_inner">
            <ChatMessageList
              ref="chatMessageListRef"
              :botId="bot_id"
              :message-list="messageList"
              :onboardingInfo="onboarding_info"
              :followUpList="followUpList"
              @send="onMessageListSend"
              @loadMore="getMessageList"
            />
          </div>
        </div>
        <footer class="ef-ai-footer">
          <div class="footer-section">
            <div class="footer-chat-icon">
              <span class="iconfont icon-yaoyueqianim"></span>
            </div>
            <div class="footer-chat-input">
              <input v-model="inputValue" class="input" type="text" placeholder="在此输入您的问题" @keyup.enter="onSend">
            </div>
            <div class="footer-chat-send" @click="onSend">
              <span class="iconfont icon-fabu" :class="{disabled: disabledSend}"></span>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <Loading v-model="pageLoading" />
  </div>
</template>

<script>
  import axios from 'axios'
  import Loading from '@/components/Loading'
  import ChatHeader from './components/ChatHeader'
  import { fetchEventSource } from '@microsoft/fetch-event-source';
  import ChatMessageList from './components/ChatMessageList'
  import { mapGetters } from 'vuex'
  import { getOnlineInfo, getConversations, createConversation, getMessageList } from '@/common/http/ai'
  import { gen_uuid } from '@/utils'

  export default {
    components: {
      Loading,
      ChatHeader,
      ChatMessageList
    },
    data() {
      return {
        // aiToken: "Bearer pat_WTn0UAzYZT2NjdwJgUTDvbZF0vPFq5V5Y5gNQ7MEviQqKdd08l078bkNEQpzslWZ",
        showClear: false,
        messageList: [],
        inputValue: '',
        conversation_id: '', // 暂无会话id
        onboarding_info: {
          prologue: "",
          suggested_questions: [] // 建议问题
        },
        conversationList: [],
        followUpList: [],
        pageLoading: false,
        successDone: true, // 是否可发送消息
        last_id: "", // 最后一条消息id
        has_more: true,
        hasCard: false // 是否卡片类型数据
      }
    },
    computed: {
      ...mapGetters(['configAi', 'bot_id', 'user_id', 'ai_token']),
      disabledSend() {
        return !this.inputValue || !this.successDone
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init(isClear) {
        const { tenantId, user_id, bot_id } = this.$route.query

        if (tenantId) {
          this.$store.commit('SET_TENANT_ID', tenantId)
        }

        if (!this.configAi) {
          return
        }

        if (bot_id) {
          this.$store.commit('SET_BOT_ID', bot_id)
        }

        if (!this.user_id) {
          this.$store.commit('SET_USER_ID', user_id || gen_uuid())
        }

        this.pageLoading = true

        try {
          if (!this.ai_token) {
            await this.$store.dispatch('getToken')
          }

          const { onboarding_info } = await this.getOnlineInfo()
          this.onboarding_info = onboarding_info

          const { conversations, has_more } = await this.getConversations()

          if (isClear) {
            this.has_more = has_more
          }

          if (conversations.length) {
            this.conversation_id = conversations[0].id
            this.getMessageList()
          } else {
            const { id: conversation_id } = await this.createConversation()
            this.conversation_id = conversation_id
          }
          this.pageLoading = false
        } catch (error) {
          console.log(error, 'init error')

          this.pageLoading = false
          this.$store.dispatch('getToken')
        }
      },
      getOnlineInfo() {
        return new Promise((resolve, reject) => {
          getOnlineInfo({ bot_id: this.bot_id }).then(res => {
            if (res.data.code === 0) {
              resolve(res.data.data)
            } else {
              reject(res.data)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      getConversations() {
        return new Promise((resolve, reject) => {
          const params = {
            bot_id: this.bot_id,
            page_num: 1,
            page_size: 1
          }
          getConversations(params).then(res => {
            if (res.data.code === 0) {
              resolve(res.data.data)
            } else {
              reject(res.data)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      createConversation() {
        return new Promise(resolve => {
          createConversation({ bot_id: this.bot_id }).then(res => {
            if (res.data.code === 0) {
              resolve(res.data.data)
            } else {
              reject(res.data)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
      formateMessageData(list) {
        const ids = list.map(item => item.chat_id)
        const idLists = Array.from(new Set(ids))

        for (let i = 0; i < list.length; i++) {
          const item = list[i]

          if (idLists.includes(item.chat_id)) {
            if (item.content_type === 'card') {
              if (i > 0) {
                let temp = list[i]
                list[i] = list[i - 1]
                list[i - 1] = temp
              }
            }
          }
        }

        return list
      },
      getMessageList(isLoadMore = false) {
        if (!this.has_more) {
          return
        }

        const params = {
          limit: 50,
          order: 'asc'
        }

        if (isLoadMore) {
          params.after_id = this.last_id
          console.log('load more message request')
        }

        getMessageList(params, { conversation_id: this.conversation_id }).then(res => {
          if (res.data.code === 0) {
            const data = res.data
            const result = data.data.sort((a, b) => a.updated_at - b.updated_at)

            // 翻页
            if (isLoadMore) {
              // this.messageList = this.formateMessageData([...result, ...this.messageList])
              this.messageList = [...result, ...this.messageList].filter(item => Boolean(item.content))
              const bottom = this.$refs.chatMessageListRef.$refs.messageListRef.scrollHeight

              this.$nextTick(() => {
                // 保持位置不变
                this.$refs.chatMessageListRef.scrollToPosition({ scrollToOffset: { bottom } })
              })
            } else {
              this.messageList = result.filter(item => Boolean(item.content))

              this.$nextTick(() => {
                this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
              })
            }

            if (this.messageList.length) {
              const suggested_questions = this.onboarding_info.suggested_questions || []
              this.followUpList = suggested_questions.slice(0, 3)
            }

            this.last_id = data.last_id
            this.has_more = data.has_more
          }
        }).catch(err => {
          this.$store.dispatch('getToken')
        })
      },
      onSend() {
        if (this.disabledSend) {
          return
        }

        if (this.successDone) {
          this.successDone = false
        }

        const params = {
          bot_id: this.bot_id,
          user_id: this.user_id,
          stream: true,
          custom_variables: {
            user_id: this.user_id,
            user_profile: ""
          },
          additional_messages: [
            { role: 'user', content_type: 'text', content: this.inputValue }
          ]
        }

        // 用户消息
        this.messageList.push({
          id: "",
          bot_id: "",
          chat_id: "",
          content: this.inputValue,
          content_type: "text",
          meta_data: {},
          reasoning_content: "",
          role: "user",
          type: "question",
        })

        // 清空下方推荐列表
        this.followUpList = []

        this.$nextTick(() => {
          this.inputValue = ""
          this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
        })

        const ctrl = new AbortController();
        fetchEventSource("https://api.coze.cn/v3/chat?conversation_id=" + this.conversation_id, {
          method: 'POST',
          headers: {
            "Authorization": this.ai_token,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(params),
          signal: ctrl.signal,
          async onopen(response) {
            console.log(response, 'onopen')
          },
          onmessage: ({ event, data }) => {
            // event:conversation.message.delta
            // data:{"id":"7477177077628731419","conversation_id":"7476016685812662310","bot_id":"7475763850227941430","role":"assistant","type":"answer","content":"那","content_type":"text","chat_id":"7477177072796925978","section_id":"7476016685812662310"}
            switch(event) {
              case "conversation.chat.created":
                this.handleConversationChatCreated(JSON.parse(data))
                break
              case "conversation.chat.in_progress":
                this.handleConversationChatInProgress(JSON.parse(data))
                break
              case "conversation.message.delta":
                this.handleConversationMessageDelta(JSON.parse(data))
                break
              case "conversation.message.completed":
                this.handleConversationMessageCompleted(JSON.parse(data))
                break
              case "done":
                this.handleConversationDone()
                break
            }
          },
          onerror: error => {
            console.log(error, 'onerror...')
            this.$store.dispatch('getToken')
          },
          onclose() {
            console.log('close...')
          }
        });
      },
      handleConversationChatCreated(data) {

        // 设置用户消息
        const userMessage = this.messageList[this.messageList.length - 1]
        userMessage.id = data.id
        userMessage.chat_id = data.id
        userMessage.conversation_id = data.conversation_id
        userMessage.created_at = data.created_at
        userMessage.section_id = data.section_id


        // 智能体消息
        this.messageList.push({
          id: "",
          bot_id: data.bot_id,
          chat_id: data.id,
          content: "",
          content_type: "text",
          conversation_id: data.conversation_id,
          created_at: data.created_at,
          meta_data: {},
          reasoning_content: "",
          role: "assistant",
          section_id: data.section_id,
          type: "answer",
          loading: true,
        })

        this.$nextTick(() => {
          this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
        })
      },
      handleConversationChatInProgress(data) {
      },
      handleConversationMessageDelta(data) {
        if (data.type !== 'answer' || data.role !== 'assistant') {
          return
        }

        const lastMessage = this.messageList[this.messageList.length - 1]

        if (lastMessage.content_type === 'text') {
          if (!lastMessage.id) {
            lastMessage.id = data.id
          }

          lastMessage.content = lastMessage.content += data.content

          this.$nextTick(() => {
            this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
          })
        }
      },
      handleConversationMessageCompleted(data) {
        if (data.type === 'answer') {
          const lastMessage = this.messageList[this.messageList.length - 1]
          if (lastMessage.loading) {
            lastMessage.loading = false
          }

          if (this.hasCard) {
            lastMessage.id = data.id
            lastMessage.chat_id = data.chat_id
            lastMessage.content_type = "card"
            lastMessage.content = data.content
            lastMessage.loading = false

            this.$nextTick(() => {
              this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
            })
          }
        }

        if (data.type === "function_call") {
          try {
            const content = JSON.parse(data.content)
            console.log(content.plugin_name, 'plugin_name')
          } catch (error) {

          }
        } else if (data.type === "tool_response") {
          if (data.content.includes('directly streaming reply')) {
            this.hasCard = true
          }
          // try {
          //   const content = JSON.parse(data.content)
          //   console.log(content, 'tool_response')

          //   // 卡片数据设置
          //   if (content.card_type != undefined) {
          //     // 更改消息
          //     const lastMessage = this.messageList[this.messageList.length - 1]
          //     if (lastMessage) {
          //       lastMessage.id = data.id
          //       lastMessage.chat_id = data.chat_id
          //       lastMessage.content_type = "card"
          //       lastMessage.content = data.content
          //       lastMessage.loading = false

          //       // 创建智能体消息 文本消息
          //       this.messageList.push({
          //         id: "",
          //         bot_id: data.bot_id,
          //         chat_id: data.chat_id,
          //         content: "",
          //         content_type: "text",
          //         conversation_id: "",
          //         created_at: "",
          //         meta_data: {},
          //         reasoning_content: "",
          //         role: "assistant",
          //         section_id: "",
          //         type: "answer",
          //         loading: true
          //       })

          //       this.$nextTick(() => {
          //         this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
          //       })
          //     }
          //   }
          // } catch (error) {
            
          // }
        } else if (data.type === "verbose") {
          try {
            const content = JSON.parse(data.content)
            if (content.msg_type.includes("stream_plugin_finish")) {
              // 创建智能体消息 文本消息
              this.messageList.push({
                id: "",
                bot_id: data.bot_id,
                chat_id: data.chat_id,
                content: "",
                content_type: "text",
                conversation_id: "",
                created_at: "",
                meta_data: {},
                reasoning_content: "",
                role: "assistant",
                section_id: "",
                type: "answer",
                loading: true
              })

              this.$nextTick(() => {
                this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
              })
            }
          } catch (error) {
            
          }
        } else if (data.type === "follow_up") {
          this.followUpList.push(data.content)

          this.$nextTick(() => {
            this.$refs.chatMessageListRef.scrollToPosition({ scrollToBottom: true })
          })
        }
      },
      handleConversationDone() {
        this.successDone = true
        this.hasCard = false

        const lastMessage = this.messageList[this.messageList.length - 1]
        
        if (!lastMessage.content) {
          lastMessage.content = '暂无查到数据'
          lastMessage.loading = false
        }
      },
      async onClearMessage() {
        if (!this.successDone) {
          return
        }

        const { id: conversation_id } = await this.createConversation()
        this.conversation_id = conversation_id
        this.messageList = []

        this.init(true)
      },
      onMessageListSend(text) {
        this.inputValue = text
        this.onSend()
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (from.path !== '/') {
          vm.showClear = true
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  .ef-ai {
    width: 100%;
    height: 100vh;
    line-height: 1.5em;
    display: flex;
    flex-direction: column;
    /* background: url("https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/chat_bg.png"); */
    background: #EAF1FF;
    background-size: 100% 100%;
  }
  .ef-ai-header {
    width: 100%;
    padding: 14px 16px 10px;
    box-sizing: border-box;
  }
  .ef-ai-content {
    flex: 1 1 auto;
    height: calc(100% - 72px);
    display: flex;
    flex-direction: column;
    background: url("../../assets/ai/ai_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 30px 30px 0 0;
  }

  .ef-ai-body {
    flex: 1 1 auto;
    border-radius: 30px 30px 0 0;
    overflow-y: scroll;
  }
  .ef-ai-body_inner {
    padding: 12px 12px 0;
    box-sizing: border-box;
    height: 100%;
  }
  .ef-ai-footer {
    width: 100%;
    height: 82px;
    padding: 8px 12px 24px;
    box-sizing: border-box;
    .footer-section {
      width: 100%;
      height: 100%;
      padding: 14px 16px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 15px;
      display: flex;
      align-items: center;
      .footer-chat-icon {
        .iconfont {
          font-size: 20px;
        }
      }
      .footer-chat-input {
        flex: 1 1 auto;
        padding: 0 12px;
        box-sizing: border-box;
        .input {
          font-size: 15px;
          width: 100%;
          border: none;
          box-shadow: none;
          outline: none;
        }
      }
      .footer-chat-send {
        .iconfont {
          font-size: 20px;
          padding: 4px;
          &.disabled{
            color: #b3b8c6;
          }
        }
      }
    }
  }
  
</style>